import RedReceiptTable from "./RedReceiptTable";

export default RedReceiptTable;
